export const formatGs = (n) => {
  const num = Math.round(Number(n) || 0);
  return "₲ " + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const discountPct = (price, original) => {
  const p = Number(price) || 0;
  const o = Number(original) || 0;
  if (o > p && p > 0) return Math.round((1 - p / o) * 100);
  return 0;
};

export const formatNumber = (n) => {
  const num = Math.round(Number(n) || 0);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-PY", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-PY", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const ORDER_STATUS = {
  aguardando_pago: { label: "Aguardando pago", color: "bg-amber-100 text-amber-700" },
  pago_confirmado: { label: "Pago confirmado", color: "bg-emerald-100 text-emerald-700" },
  procesando: { label: "Procesando", color: "bg-blue-100 text-blue-700" },
  completado: { label: "Completado", color: "bg-indigo-100 text-indigo-700" },
  cancelado: { label: "Cancelado", color: "bg-rose-100 text-rose-700" },
};

export const COMP_STATUS = {
  aguardando_analisis: { label: "Aguardando análisis", color: "bg-amber-100 text-amber-700" },
  aprobado: { label: "Aprobado", color: "bg-emerald-100 text-emerald-700" },
  rechazado: { label: "Rechazado", color: "bg-rose-100 text-rose-700" },
};
